import type { RouteDefinition } from "../route-definition.ts";

export const adminCommunityRoutes = {
  "admin.community": {
    path: "/admin/community",
    scope: "static",
    bucket: "admin",
    entry: "nav",
    disposition: "page",
  },
  "admin.forums": {
    path: "/admin/community/forums",
    scope: "static",
    bucket: "admin",
    entry: "compatibility",
    disposition: "resolver",
  },
  "admin.wikis": {
    path: "/admin/community/wikis",
    scope: "static",
    bucket: "admin",
    entry: "compatibility",
    disposition: "resolver",
  },
  "admin.forum": {
    path: "/admin/community/forums/:slug",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.forumPost": {
    path: "/admin/community/forums/:slug/:postId",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.wiki": {
    path: "/admin/community/wikis/:slug/*page?",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
} as const satisfies Record<string, RouteDefinition>;
